/**
 * Spalten-Definition fuer das Kanban-Board.
 *
 * LOCKED via Phase 3 CONTEXT.md: 7 Spalten in fester Reihenfolge.
 * Reihenfolge ist HARDCODED — kein Reorder per Drag&Drop.
 *
 * Sortierung pro Spalte (BOARD-05):
 * - Spalten 1/2/3 (Follow-up-Pipeline): aelteste Karten oben (oldest_first)
 * - Spalten 4/5/6/7 (statisch + Abschluss): neueste oben (newest_first)
 */

import type { LeadStatus } from '../types';

export interface ColumnDef {
  status: LeadStatus;
  label: string;
  sort: 'oldest_first' | 'newest_first';
}

export const COLUMNS: readonly ColumnDef[] = [
  { status: 'lead_form', label: 'Lead-Formular ausgefuellt', sort: 'oldest_first' },
  { status: 'followup_1', label: 'Follow-up 1', sort: 'oldest_first' },
  { status: 'followup_2', label: 'Follow-up 2', sort: 'oldest_first' },
  { status: 'in_kontakt', label: 'In Kontakt', sort: 'newest_first' },
  { status: 'positiv', label: 'Positiv abgeschlossen', sort: 'newest_first' },
  { status: 'negativ', label: 'Negativ abgeschlossen', sort: 'newest_first' },
  { status: 'negativ_hotlead', label: 'Negativ Hotlead', sort: 'newest_first' },
];

export function getColumnDef(status: LeadStatus): ColumnDef | undefined {
  return COLUMNS.find((c) => c.status === status);
}
